/* eslint-disable no-nested-ternary */
import React, { Component } from "react";
import PropTypes from "prop-types";
import padStart from "lodash/padStart";

import moment from "../../lib/moment";
import "./View.scss";

const noopT = t => t;

/**
 * Countdown View
 */
class View extends Component {
  static propTypes = {
    rootClassName: PropTypes.string,
    activeClassName: PropTypes.string,
    deliveryFromTime: PropTypes.string,
    deliveryTillTime: PropTypes.string,
    postToPage: PropTypes.bool,
    time: PropTypes.number.isRequired,
    realtime: PropTypes.number.isRequired,
    isTodayPossible: PropTypes.bool.isRequired,
    isTomorrowPossible: PropTypes.bool.isRequired,
    hasPostcodeCheck: PropTypes.bool.isRequired,
    nextDate: PropTypes.string.isRequired,
    t: PropTypes.func,
    id: PropTypes.number,
    hydrate: PropTypes.func.isRequired,
    orderBeforeTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    nextPossibleDate: PropTypes.string,
    usedPostcode: PropTypes.string,
    isFreshProduct: PropTypes.bool,
    isPostcodePossible: PropTypes.bool,
    isFetching: PropTypes.bool.isRequired,
    inCart: PropTypes.bool
  };

  static defaultProps = {
    rootClassName: "CountdownClock",
    activeClassName: "",
    inCart: false,
    postToPage: false,
    isPostcodePossible: false,
    t: noopT,
    id: 0,
    orderBeforeTime: 0,
    nextPossibleDate: "",
    usedPostcode: "",
    isFreshProduct: true
  };

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();

    this.state = {
      isTodayPossible: props.isTodayPossible,
      displayPostcodeCheck: props.hasPostcodeCheck,
      time: 0,
      hours: null,
      minutes: null,
      seconds: null,
      text: null
    };
  }

  componentWillMount() {
    this.onUpdateClock();
  }

  componentWillReceiveProps(props) {
    if (
      this.props.time !== props.time ||
      this.props.isTodayPossible !== props.isTodayPossible ||
      this.props.hasPostcodeCheck !== props.hasPostcodeCheck
    ) {
      this.setState({
        time: props.time,
        isTodayPossible: props.isTodayPossible,
        displayPostcodeCheck: props.hasPostcodeCheck
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  onSubmitPostcode = e => {
    if (this.props.postToPage) {
      return true;
    }
    this.inputRef.current.value = this.inputRef.current.value.trim().replace(/\s+/g, " ");
    this.props.hydrate(this.props.id, this.inputRef.current.value, this.props.realtime ? this.state.time : 0);
    e.preventDefault();
    return false;
  };

  onUpdateClock = () => {
    if (!this.interval) {
      this.interval = setInterval(this.onUpdateClock, 1000);
    }
    const time = this.state.time || this.props.time;
    if (!time || !this.props.isTodayPossible || !this.state.isTodayPossible) {
      return;
    }
    const { nextPossibleDate, orderBeforeTime } = this.props;

    const now = moment(time);
    let displayPostcodeCheck = this.state.hasPostcodeCheck || this.props.hasPostcodeCheck;
    let secondsToTarget = 0;

    const orderBefore = orderBeforeTime ? moment(`${nextPossibleDate} ${orderBeforeTime}`) : null;

    const m1129 = moment(time)
      .hour(11)
      .minute(29)
      .second(0);
    const m1131 = moment(time)
      .hour(11)
      .minute(31)
      .second(0);
    const m1159 = moment(time)
      .hour(11)
      .minute(59)
      .second(0);
    const m1201 = moment(time)
      .hour(12)
      .minute(1)
      .second(0);

    const m1359 = moment(time)
      .hour(13)
      .minute(59)
      .second(0);
    const m1401 = moment(time)
      .hour(14)
      .minute(1)
      .second(0);

    const m1459 = moment(time)
      .hour(14)
      .minute(59)
      .second(0);
    const m1501 = moment(time)
      .hour(15)
      .minute(1)
      .second(0);

    const m2359 = moment(time)
      .hour(23)
      .minute(59)
      .second(0);
    // eslint-disable-next-line newline-per-chained-call
    const m0001 = moment(time)
      .day(1)
      .hour(0)
      .minute(1)
      .second(0);

    // update every ten minutes,
    // and every minute between 11:29 and 11:30
    // and every minute between 11:59 and 12:00
    // and every minute between 13:59 and 14:00
    // and every minute between 14:59 and 15:00
    // and every minute between 23:59 and 00:00
    if (this.props.id && (window.Math.round(time / 1000) / 60) % 10 === 1) {
      this.props.hydrate(
        this.props.id,
        this.inputRef && this.inputRef.current ? this.inputRef.current.value.trim() : null,
        this.props.realtime ? this.state.time : 0
      );
    } else if (
      this.props.id &&
      window.Math.round(time / 1000) % 60 === 1 &&
      (now.isBetween(m1129, m1131) ||
        now.isBetween(m1159, m1201) ||
        now.isBetween(m1359, m1401) ||
        now.isBetween(m1459, m1501) ||
        now.isBetween(m2359, m0001))
    ) {
      this.props.hydrate(
        this.props.id,
        this.inputRef && this.inputRef.current ? this.inputRef.current.value.trim() : null,
        this.props.realtime ? this.state.time : 0
      );
    }

    //
    const m15u = moment(time)
      .hour(15)
      .minute(0)
      .second(0);
    if (now.isBefore(m15u)) {
      if (!orderBefore) {
        secondsToTarget = m15u.diff(now, "seconds");
      }
    }

    const m14u = moment(time)
      .hour(14)
      .minute(0)
      .second(0);
    if (now.isBefore(m14u)) {
      if (!orderBefore) {
        secondsToTarget = m14u.diff(now, "seconds");
      }
    }

    if (orderBefore && now.isBefore(orderBefore)) {
      secondsToTarget = orderBefore.diff(now, "seconds");
    }

    let seconds = secondsToTarget;
    const hours = window.Math.floor(secondsToTarget / 3600);
    seconds -= hours * 3600;
    const minutes = window.Math.floor(seconds / 60);
    seconds -= minutes * 60;

    if (secondsToTarget === 0) {
      this.props.hydrate(
        this.props.id,
        this.inputRef && this.inputRef.current ? this.inputRef.current.value.trim() : null,
        this.props.realtime ? this.state.time : 0
      );
    }

    this.setState({
      time: time + 1000,
      displayPostcodeCheck,
      hours: secondsToTarget === 0 ? 0 : hours,
      minutes: secondsToTarget === 0 ? 0 : minutes,
      seconds: secondsToTarget === 0 ? 0 : seconds,
      text: this.getText(now),
      isTodayPossible: secondsToTarget === 0 ? false : this.props.isTodayPossible
    });
  };

  getText(today) {
    const { t, nextPossibleDate, orderBeforeTime, isFreshProduct, deliveryFromTime, deliveryTillTime } = this.props;

    const tomorrow = moment(today).add(1, "day");

    const deliveryDate = moment(nextPossibleDate).hours(12);
    const isDeliverySaturday = deliveryDate.day() === 6;
    const isDeliverySunday = deliveryDate.day() === 0;
    const isTodaySaturday = today.day() === 6;
    const isAfterFive = today.isAfter(
      moment(today)
        .hours(17)
        .minutes(0)
    );

    // eslint-disable-next-line no-nested-ternary
    const deliveryMoment = deliveryDate.isSame(today, "day")
      ? "today"
      : deliveryDate.isSame(tomorrow, "day")
      ? "tomorrow"
      : deliveryDate.format("dddd D MMMM");

    let deliveryMomentText = "";
    if (deliveryMoment === "today") {
      deliveryMomentText = t("today");
    } else if (deliveryMoment === "tomorrow" && isAfterFive && !isTodaySaturday) {
      deliveryMomentText = t("tomorrow");
    } else if (isDeliverySaturday || isDeliverySunday || orderBeforeTime === "17:00") {
      deliveryMomentText = "";
    } else {
      deliveryMomentText = deliveryMoment === "tomorrow" ? t("tomorrow") : deliveryMoment;
    }

    if (isFreshProduct) {
      deliveryMomentText = "";
    }

    if (!deliveryMomentText) {
      return "";
    }

    return t("eveningDelivery", { date: deliveryMomentText, deliveryFromTime, deliveryTillTime });
  }

  renderPostcodeCheck() {
    if (!this.state.displayPostcodeCheck) {
      return null;
    }

    const classNames = [`${this.props.rootClassName}__PostcodeCheck`].filter(v => !!v);

    if (this.props.inCart) {
      classNames.push(`${this.props.rootClassName}__PostcodeCheck--vertical`);
    }

    return (
      <form method="get" name="filter[postcode]" className={classNames.join(" ")}>
        <div className={`${this.props.rootClassName}__PostcodeCheck__Title`}>
          {this.props.t("Deliver flowers today?")}
          <br />
          {this.props.t("Check if delivery is possible")}
        </div>
        <div className={`${this.props.rootClassName}__PostcodeCheck__Input`}>
          <label htmlFor="zipcode">
            <input
              aria-label="Postcode"
              type="text"
              required
              minLength="6"
              pattern="[1-9][0-9]{3}\s*[a-zA-Z]{2}\s*"
              defaultValue={this.props.usedPostcode}
              placeholder={this.props.t("e.g. 2231 LA")}
              id="zipcode"
              name="zipcode"
              ref={this.inputRef}
            />
            {!this.props.postToPage && this.props.usedPostcode && (
              <i className={`fa ${this.props.isPostcodePossible ? "fa-check" : "fa-times"}`} />
            )}
          </label>
          <button type="submit" className="btn btn-secondary" onClick={this.onSubmitPostcode}>
            {this.props.t("check2")}
          </button>
        </div>
      </form>
    );
  }

  renderClock() {
    const cls = this.props.rootClassName;
    const { hours, minutes, seconds } = this.state;
    return (
      <React.Fragment>
        <span key="prefix">{this.props.t("just")} &nbsp;</span>
        <span key="hours" className={`${cls}__TimeValue`}>
          {padStart(hours, 2, 0)}
        </span>
        <span key="hours-sep" className={`${cls}__TimeSeparator`}>
          :
        </span>
        <span key="minutes" className={`${cls}__TimeValue`}>
          {padStart(minutes, 2, 0)}
        </span>
        <span key="minutes-sep" className={`${cls}__TimeSeparator`}>
          :
        </span>
        <span key="seconds" className={`${cls}__TimeValue`}>
          {padStart(seconds, 2, 0)}
        </span>
        <span key="suffix">&nbsp; {this.props.t("for delivery today")}</span>
      </React.Fragment>
    );
  }

  renderNextMoment() {
    const { isTomorrowPossible, nextDate, isFetching } = this.props;
    if ((this.state.displayPostcodeCheck && !this.props.usedPostcode) || isFetching) {
      return null;
    }
    if (this.state.isTodayPossible) {
      return <div>{this.renderClock()}</div>;
    }
    return (
      <div className={`${this.props.rootClassName}__NextMoment`}>
        {this.props.t("Next delivery moment is")}
        <div>{isFetching ? "..." : isTomorrowPossible ? this.props.t("tomorrow") : nextDate}</div>
      </div>
    );
  }

  render() {
    return (
      <div className={`${this.props.rootClassName} ${this.props.activeClassName ? this.props.activeClassName : ""}`}>
        {this.renderPostcodeCheck()}
        {this.renderNextMoment()}
        {!this.state.displayPostcodeCheck && this.state.text && <div>{this.state.text}</div>}
      </div>
    );
  }
}

export default View;
